export default { 
    
    // Data
    item: {
        id: 0,
        owner: '',
        wordCount: 0,
        maxGuesses: 0,
        letterPerWord: [],
        guesses: [],
        category: '',
        winner: '',
        isComplete: false
    },
    items: [],
    users: [],

    // Filtering
    filtering: false,
    filters: {
        type: 'all',
        search: '',
    },
    
    // UI
    loading: true,
    contentLoading: false,
    loginLoading: false,
    hasExtension: true,
    pendingTransaction: false
}


// WEBPACK FOOTER //
// ./src/store/state.js